'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var Spinner_module = require('./Spinner.module.css.js');
var d = require('./d.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const BitIconSpinner = ({
  s,
  className = ''
}) => {
  const classes = clsx__default["default"]({
    [Spinner_module["default"].container]: true,
    [className]: true
  });
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    style: s,
    role: "status",
    className: classes,
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: d["default"]
  }));
};

exports["default"] = BitIconSpinner;
